const sm2 = require('sm-crypto').sm2

const publicKey = "0496662dc7198bcf7d87a9623c2ae3b71f1ef37cc72554d5ee336a2c27e4026b0a42faeb948f85f350274966405a168b17e932756c33de6c2949739ff9897906b4"

const SM2 ={}

//加密
SM2.doEncrypt = function (data){
    return sm2.doEncrypt(data, publicKey);
}


export default SM2
